import React from "react";
import { styled } from "@linaria/react";
import t from "../../../../i18n";
import Switch from "@ui/Switch";
import { useFilledData } from "../../../../api/useReporting";

const FilledDataSwitch = styled(Switch)`
  height: 32px;
  min-height: unset;
  margin-left: auto;
  margin-right: 4px;
`;

function FilledDataToggle() {
  const [filledData, setFilledData] = useFilledData({});
  return (
    <FilledDataSwitch checked={filledData} onChange={e => setFilledData(e.currentTarget.checked)}>
      {t("reporting.header.fill_gaps")}
    </FilledDataSwitch>
  );
}

export default FilledDataToggle;
